import styled from 'styled-components';
import { Box } from '@99designs/emu';
import { VimeoVideoPlayer } from '../../VimeoVideoPlayer/VimeoVideoPlayer';

const HOW_IT_WORKS_VIDEO_VIMEO_ID = '1190366886';

const VideoWrapper = styled(Box)`
    width: auto;
    @media (min-width: 900px) and (max-width: 1050px) {
        width: 500px;
    }

    @media (min-width: 1050px) and (max-width: 1300px) {
        width: 600px;
    }
`;

export default function HowItWorksVideo() {
    return (
        <VideoWrapper
            marginLeft={['none', 'none', '4bu', '4bu']}
            marginTop={['2bu', '2bu', 'none', 'none']}
        >
            <VimeoVideoPlayer
                id={HOW_IT_WORKS_VIDEO_VIMEO_ID}
                style={{ height: '350px', position: 'relative', width: '710px' }}
            />
        </VideoWrapper>
    );
}
